<ng-container *ngIf="isBuyingWindow">
  <div class="allocation-group--container" [ngClass]="{'m-0': isHidden }">
    <div *ngIf="enabled && !readonly">

      <div class="label color--primary-grey">Allocation Group</div>

      <div *ngIf="filteredAllocationGroups$ | async; let allocationGroups; else loading">

        <ng-select
          class="ng-select--custom searchable address--selector"
          [items]="allocationGroups"
          bindValue="allocation_group_id"
          placeholder="Select Allocation Group"
          [searchable]="true"
          [typeahead]="searchSubject"
          (change)="onSelect($event)"
          [clearable]="false"
          dropdownPosition="bottom"
          [(ngModel)]="delivery.allocation_group_id"
          notFoundText="No items found"
          typeToSearchText="No items found">
          <ng-template ng-label-tmp let-item="item">
            <span class="d-block font-weight-bold font-5">{{ item.allocation_group_label }}</span>
            <span *ngIf="!isBuyingWindow">{{  item.available_qty }}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
                  <span class="font-weight-bold font-6">
                      {{ item.allocation_group_label }}
                  </span>
            <span class="font-6" *ngIf="!isBuyingWindow">{{ item.available_qty }}</span>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!--  Readonly View-->
    <div *ngIf="readonly && hasSelectedAllocationGroup" class="readonly-view">
      <div class="label color--primary-grey">Allocation Group</div>
      <strong  class="d-block text-break-all">{{delivery.allocation_group_label}}</strong>
    </div>
  </div>
</ng-container>


<ng-template #loading>
    <div class="content-loader small mt-3">
        <div class="inline-loader"></div>
    </div>
</ng-template>

